import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@enlighten/design-system/dist/Button';
import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import Image from 'next/image';
import ImgBg from '../../assets/images/hanwha/section-8-bg.png';
import TitleImg from '../../assets/images/hanwha/section-8-title.png';
const PHONE_NUMBER = '1644-9664';
export default function Section8({ onClickPhone, onClickOnline, }) {
    return (_jsx(Stack, { justifyContent: "center", alignItems: "center", 
        // bgcolor="#F37321"
        paddingX: 3, paddingY: { xs: '60px', md: 16 }, sx: {
            background: `url(${process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true'
                ? ImgBg.src
                : ImgBg}) no-repeat center / cover`,
        }, children: _jsxs(Stack, { gap: 2, maxWidth: 1392, width: "100%", children: [_jsxs(Stack, { sx: {
                        '& img': {
                            width: '100%',
                            maxWidth: { xs: 280, md: 460 },
                            height: 'auto',
                        },
                    }, children: [process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                            process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { src: TitleImg, alt: '한화손해보험\u00d7TPA코리아', width: 460 })) : (_jsx("img", { src: TitleImg, alt: '한화손해보험\u00d7TPA코리아', width: 460 })), _jsx(Typography, { fontSize: { xs: 24, md: 40 }, fontWeight: 700, color: "common.white", children: `태양광발전소종합보험
종합 보장 혜택을 누려보세요.` })] }), _jsxs(Stack, { display: { xs: 'none', md: 'flex' }, direction: "row", alignItems: "center", gap: 2, children: [_jsxs(Button, { variant: "outlined", onClick: onClickPhone, sx: {
                                bgcolor: 'common.white',
                                color: '#F37321',
                                transition: 'color 0.3s ease',
                                ':hover': {
                                    color: '#FFAA75',
                                },
                            }, children: ["\uC804\uD654 \uC0C1\uB2F4 (TPA\uCF54\uB9AC\uC544) ", PHONE_NUMBER] }), _jsx(Button, { variant: "outlined", onClick: onClickOnline, sx: {
                                bgcolor: 'common.white',
                                color: '#F37321',
                                transition: 'color 0.3s ease',
                                ':hover': {
                                    color: '#FFAA75',
                                },
                            }, children: "\uC628\uB77C\uC778 \uACAC\uC801\uBB38\uC758" })] }), _jsxs(Stack, { display: { xs: 'flex', md: 'none' }, direction: "row", alignItems: "center", flexWrap: "wrap", gap: 2, children: [_jsx(Button, { variant: "outlined", onClick: onClickPhone, sx: {
                                bgcolor: 'common.white',
                                paddingX: 3,
                                transition: 'color 0.3s ease',
                                ':hover': {
                                    color: '#F37321',
                                },
                            }, children: "\uC804\uD654 \uC0C1\uB2F4 (TPA\uCF54\uB9AC\uC544)" }), _jsx(Button, { variant: "outlined", onClick: onClickOnline, sx: {
                                bgcolor: 'common.white',
                                paddingX: 3,
                                transition: 'color 0.3s ease',
                                ':hover': {
                                    color: '#F37321',
                                },
                            }, children: "\uC628\uB77C\uC778 \uACAC\uC801\uBB38\uC758" })] })] }) }));
}
